// Generated by BUCKLESCRIPT VERSION 4.0.18, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../Utils.js");
var React = require("react");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var ReactDOMRe = require("reason-react/lib/js/src/ReactDOMRe.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

function str(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("NewsColumns");

function unaCard($staropt$star, children) {
  var border = $staropt$star !== undefined ? $staropt$star : "none";
  return ReactDOMRe.createElementVariadic("div", {
              "data-border": border,
              "data-flow": "vertical",
              class: "una-card text-center"
            }, children);
}

function unaCardTime(item) {
  return ReactDOMRe.createElementVariadic("time", {
              "data-color": "grayBlue"
            }, /* array */[
              item[/* date */0] + " | ",
              ReactDOMRe.createElementVariadic("a", {
                    href: item[/* editorialLink */6],
                    target: "_blank",
                    "data-color": "grayBlue"
                  }, /* array */[item[/* editorialTitle */4]])
            ]);
}

function unaCardTitle($staropt$star, $staropt$star$1, item) {
  var size = $staropt$star !== undefined ? $staropt$star : "small";
  var search = $staropt$star$1 !== undefined ? $staropt$star$1 : "";
  return ReactDOMRe.createElementVariadic("h3", {
              class: "una-card__title",
              "data-color": "darkBlue",
              "data-font-weight": "medium",
              "data-size": size
            }, /* array */[React.cloneElement(React.createElement("a", {
                        href: item[/* link */1],
                        target: "_blank",
                        dangerouslySetInnerHTML: {
                          __html: Utils.$$String[/* mark */0](item[/* title */2], search)
                        }
                      }), {
                    "data-color": "grayBlue"
                  })]);
}

function make(news, $staropt$star, param) {
  var search = $staropt$star !== undefined ? $staropt$star : "";
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (param) {
              return React.createElement("div", {
                          style: {
                            display: "flex",
                            flexWrap: "wrap"
                          }
                        }, Utils.List[/* mapToElement */0]((function (idx, item) {
                                var match = idx === 0;
                                return React.createElement("div", {
                                            className: "una-card-wrapper"
                                          }, unaCard(undefined, /* array */[
                                                React.createElement("a", {
                                                      className: "una-card__image",
                                                      style: {
                                                        backgroundImage: "url('" + (item[/* thumb */7] + "')")
                                                      }
                                                    }),
                                                React.createElement("div", {
                                                      className: "una-card__content"
                                                    }, unaCardTime(item), unaCardTitle(match ? "small" : "extraSmall", search, item))
                                              ]));
                              }), Belt_List.getExn(news, 0)[/* items */1]));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* jsElementWrapped */component[/* jsElementWrapped */13]
        ];
}

exports.str = str;
exports.component = component;
exports.unaCard = unaCard;
exports.unaCardTime = unaCardTime;
exports.unaCardTitle = unaCardTitle;
exports.make = make;
/* component Not a pure module */
